import React from 'react'
import { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { svgIdentifier } from 'ui/svg/utils'

import { AccessibleIcon } from './types'

const UbbleDarkSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  accessibilityLabel,
  testID,
}) => {
  const { id: clipPathId } = svgIdentifier()

  return (
    <AccessibleSvg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G clipPath={`url(#${clipPathId})`}>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.1847 13.0208C81.7137 18.5067 77.6981 23.3829 72.2156 23.9122C45.7549 26.4667 23.946 47.8274 23.946 72.3374C23.946 77.8487 19.4809 82.3165 13.973 82.3165C8.46506 82.3165 4 77.8487 4 72.3374C4 35.6949 35.5665 7.39926 70.3001 4.0461C75.7826 3.51682 80.6558 7.53494 81.1847 13.0208Z"
          fill="#FFFFFF"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.973 117.723C19.4809 117.723 23.946 122.19 23.946 127.702C23.946 153.516 46.838 176.041 71.936 176.041C77.4439 176.041 81.909 180.509 81.909 186.02C81.909 191.531 77.4439 195.999 71.936 195.999C35.8397 195.999 4 164.557 4 127.702C4 122.19 8.46506 117.723 13.973 117.723Z"
          fill="#FFFFFF"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M186.027 117.723C191.535 117.723 196 122.19 196 127.702C196 164.342 165.729 195.919 128.782 195.919C123.274 195.919 118.809 191.452 118.809 185.94C118.809 180.429 123.274 175.961 128.782 175.961C154.306 175.961 176.054 153.731 176.054 127.702C176.054 122.19 180.519 117.723 186.027 117.723Z"
          fill="#FFFFFF"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.769 13.9792C118.769 8.46783 123.234 4 128.742 4C165.08 4 196 36.4852 196 72.3374C196 77.8487 191.535 82.3166 186.027 82.3166C180.519 82.3166 176.054 77.8487 176.054 72.3374C176.054 47.0372 153.599 23.9583 128.742 23.9583C123.234 23.9583 118.769 19.4905 118.769 13.9792Z"
          fill="#FFFFFF"
        />
        <Path
          d="M115.937 71.3376C121.312 71.3376 125.67 66.9797 125.67 61.604C125.67 56.2283 121.312 51.8704 115.937 51.8704C110.561 51.8704 106.203 56.2283 106.203 61.604C106.203 66.9797 110.561 71.3376 115.937 71.3376Z"
          fill="#FFFFFF"
        />
        <Path
          d="M83.824 71.3376C89.1997 71.3376 93.5576 66.9797 93.5576 61.604C93.5576 56.2283 89.1997 51.8704 83.824 51.8704C78.4482 51.8704 74.0903 56.2283 74.0903 61.604C74.0903 66.9797 78.4482 71.3376 83.824 71.3376Z"
          fill="#FFFFFF"
        />
        <Path
          d="M115.937 148.568C121.312 148.568 125.67 144.21 125.67 138.835C125.67 133.459 121.312 129.101 115.937 129.101C110.561 129.101 106.203 133.459 106.203 138.835C106.203 144.21 110.561 148.568 115.937 148.568Z"
          fill="#FFFFFF"
        />
        <Path
          d="M83.824 148.568C89.1997 148.568 93.5576 144.21 93.5576 138.835C93.5576 133.459 89.1997 129.101 83.824 129.101C78.4482 129.101 74.0903 133.459 74.0903 138.835C74.0903 144.21 78.4482 148.568 83.824 148.568Z"
          fill="#FFFFFF"
        />
        <Path
          d="M61.1252 93.8765C66.501 93.8765 70.8589 89.5186 70.8589 84.1428C70.8589 78.7671 66.501 74.4092 61.1252 74.4092C55.7495 74.4092 51.3916 78.7671 51.3916 84.1428C51.3916 89.5186 55.7495 93.8765 61.1252 93.8765Z"
          fill="#FFFFFF"
        />
        <Path
          d="M138.555 93.8765C143.931 93.8765 148.289 89.5186 148.289 84.1428C148.289 78.7671 143.931 74.4092 138.555 74.4092C133.18 74.4092 128.822 78.7671 128.822 84.1428C128.822 89.5186 133.18 93.8765 138.555 93.8765Z"
          fill="#FFFFFF"
        />
        <Path
          d="M61.1252 126.069C66.501 126.069 70.8589 121.711 70.8589 116.336C70.8589 110.96 66.501 106.602 61.1252 106.602C55.7495 106.602 51.3916 110.96 51.3916 116.336C51.3916 121.711 55.7495 126.069 61.1252 126.069Z"
          fill="#FFFFFF"
        />
        <Path
          d="M138.555 126.069C143.931 126.069 148.289 121.711 148.289 116.336C148.289 110.96 143.931 106.602 138.555 106.602C133.18 106.602 128.822 110.96 128.822 116.336C128.822 121.711 133.18 126.069 138.555 126.069Z"
          fill="#FFFFFF"
        />
      </G>

      <Defs>
        <ClipPath id={clipPathId}>
          <Rect width="192" height="192" x="4" y="4" />
        </ClipPath>
      </Defs>
    </AccessibleSvg>
  )
}

export const UbbleDark = styled(UbbleDarkSvg).attrs(({ size, theme }) => ({
  size: size ?? theme.designSystem.size.icon.l,
}))``
